import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { RelatedProduct } from '@repo/user-types'

const initialState: GenericOperationState<RelatedProduct[] | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const {
  actions: mailingAddressRelatedProductsDataActions,
  reducer: mailingAddressRelatedProductsDataReducer,
} = createOperationSlice<
  RelatedProduct[] | null,
  SliceCaseReducers<GenericOperationState<RelatedProduct[] | null>>
>({
  name: '@users/mailingAddressRelatedProducts',
  initialState,
  reducers: {},
})
